module.exports = __webpack_public_path__ + "static/media/Backpack_Character.402a3bb6.jpg";